module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXBAMAAADn+kIjAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUdwTNTf/9bk/9bk/9bl/9bl/8/f/9bk/9Pj/9Xk/9Ti/9bl/9bk/9bk/4+6TS8AAAANdFJOUwAghe/fnxC/QGNbr8+3t8e4AAAArklEQVQY02NgU74LA04JDDx3EaCAYS4S7yZD7CUGGNC9isabezkBymG0vQk0JQDKY73rwMBx9waUJ3t3AQND7XUoz/cqkBC+OwHM4bx7EUgy3XUD81LuKgBJNluIHbpXwIbPvSwAMh/oEhBgv7sBaj4IQOzovSsAMTr2Osx8BqgdnHcNoTymu2YMImDzQYDN9xLQfLhX1t4VhJoPsQMUCgxwn929LADnMUhfLgTTAHjhUT5BSpR7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/arrow.png
// module id = Hcmf
// module chunks = 1